<!-- Nothing at all without a session: the footer belongs to the signed-in
     person, and a signed-out shell has none. -->
@if (auth.user(); as user) {
  @if (open()) {
    <!-- Above the trigger, inside the sidebar's dark palette. The entering and
         leaving classes carry the design system's popup motion. -->
    <div
      class="user-menu__popup"
      [id]="popupId"
      role="menu"
      [attr.aria-label]="'user.menu' | translate"
      animate.enter="user-menu__popup--enter"
      animate.leave="user-menu__popup--leave"
      (keydown)="onMenuKeydown($event)"
    >
      <div class="user-menu__header">
        <span class="user-menu__name">{{ user.displayName }}</span>
        @if (auth.email(); as email) {
          <span class="user-menu__email">{{ email }}</span>
        }
      </div>

      @if (links.length > 0) {
        <div class="user-menu__group">
          @for (link of links; track link.id) {
            <!-- Every destination is another site — opened aside, so the
                 work in the shell stays where it is. -->
            <a
              class="user-menu__item"
              [class.user-menu__item--accent]="link.accent"
              role="menuitem"
              [href]="link.href"
              target="_blank"
              rel="noopener"
              (click)="close(false)"
            >
              <i class="user-menu__icon" [class]="link.icon" aria-hidden="true"></i>
              <span class="user-menu__label">
                <span>{{ link.labelKey | translate }}</span>
                @if (link.hintKey; as hintKey) {
                  <span class="user-menu__hint">{{ hintKey | translate }}</span>
                }
              </span>
              @if (link.accent) {
                <i class="user-menu__external pi pi-external-link" aria-hidden="true"></i>
              }
            </a>
          }
        </div>
      }

      <div class="user-menu__group user-menu__group--exit">
        <button
          type="button"
          class="user-menu__item user-menu__item--danger user-menu__sign-out"
          role="menuitem"
          (click)="signOut()"
        >
          <i class="user-menu__icon pi pi-sign-out" aria-hidden="true"></i>
          <span class="user-menu__label">{{ 'header.signOut' | translate }}</span>
        </button>
      </div>
    </div>
  }

  <!-- The whole row is the menu button. The name is display only — it comes
       from the token, or from UMC when it knows a better one. In the full
       column the row's own text names the button; on the rail only the
       monogram is left, so the name is supplied. -->
  <button
    type="button"
    class="user-menu__trigger"
    [class.user-menu__trigger--open]="open()"
    aria-haspopup="menu"
    [attr.aria-expanded]="open()"
    [attr.aria-controls]="open() ? popupId : null"
    [attr.aria-label]="rail() ? user.displayName : null"
    [title]="user.displayName"
    (click)="toggle()"
  >
    <span class="user-menu__avatar" aria-hidden="true">{{ initials() }}</span>
    @if (!rail()) {
      <span class="user-menu__who">
        <span class="user-menu__name">{{ user.displayName }}</span>
        @if (auth.email(); as email) {
          <span class="user-menu__email">{{ email }}</span>
        }
      </span>
      <i class="user-menu__chevron pi pi-chevron-down" aria-hidden="true"></i>
    }
  </button>
}
